
















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class PasswordInput extends Vue {

  @Prop({ default: 'lock' }) icon!: string;
  @Prop() label!: string;
  @Prop() name!: string;
  @Prop() value!: string;

  @Emit('input') emitInput() { }

  isShown = false;

}
